// extracted by mini-css-extract-plugin
module.exports =  {"container":"y9Y59wi","divider":"Vy0wTe_"};